import firebase from 'firebase/app'
import 'firebase/storage'

const _getRealUrl = async (fileRef, originalUrl) => {
  let url = await fileRef.getDownloadURL().catch((err) => console.error(err))

  // add a fake URL query so that the plugin recognizes
  // this is a video.
  // https://github.com/editor-js/image/blob/212cdb21ce8dbd0033c535c665c66131c0446b00/src/ui.js#L152
  if (originalUrl.endsWith('.mp4') || originalUrl.endsWith('.mov')) {
    url += '&extension=.mp4'
  }

  return url
}

const uploadFile = async (file, channel_id, page_id) => {
    let ref = firebase.storage().ref().child('channels').child(channel_id)
    if (page_id) {
      ref = ref.child(page_id)
    }
    let fileName = Math.random().toString(36).substring(2, 15) + file.name.replace(/\s+/g, '')
    let fileRef = ref.child(fileName)
    await fileRef.put(file)

    return {
      success: 1,
      file: {
        url: await _getRealUrl(fileRef, file.name)
      }
    }
}

const serializeImage = (url) => {
  let objectSplit = url.split('/o/')
  let objectPath = url
  if (objectSplit.length > 1) {
    let objectPiece = objectSplit[1]
    let querySplit = objectPiece.split('?')
    objectPath = decodeURIComponent(querySplit[0])
  }

  return objectPath
}

const deserializeImage = async (fileUrl) => {
  let imageRef = firebase.storage().ref().child(fileUrl)
  return await _getRealUrl(imageRef, fileUrl)
}

export {
uploadFile,
serializeImage,
deserializeImage
}
